import { Dispatch, MouseEvent, SetStateAction } from 'react';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Menu } from '@mui/material';

type arrMenuProps = {
    title: string
    icon: JSX.Element
    handle: (event: MouseEvent<HTMLElement>) => void,
}

type IconMenuProps = {
    anchorEl: any,
    setAnchorEl: any,
    arrMenu: arrMenuProps[],
    subMenu?: boolean,
}

export default function IconMenu({ anchorEl, setAnchorEl, arrMenu, subMenu = false }: IconMenuProps) {
    function handleClose() {
        setAnchorEl(null);
    }

    return (
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            MenuListProps={{
                'aria-labelledby': 'basic-button',
            }}
            anchorOrigin={subMenu ? {
                vertical: "top",
                horizontal: "right", // Abre à direita do item pai
            } : undefined}
            transformOrigin={subMenu ? {
                vertical: "top",
                horizontal: "left", // Alinha a borda esquerda do submenu com a borda direita do item pai
            } : undefined}
        >
            <MenuList>
                {arrMenu.map((item, index) => (
                    <MenuItem
                        key={`menuItem${index}`}
                        onClick={item.handle}
                    >
                        <ListItemIcon>
                            {item.icon}
                        </ListItemIcon>
                        <ListItemText>{item.title}</ListItemText>
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    );
}